<template>
  <div class="user-outer">
    <div class="user-inner">
      <div class="user-header">
        <div class="logo" @click="goHome()">
          <img src="/logo.png" />
          <span>首页</span>
        </div>
        <span class="title">个人账号设置</span>
      </div>
      <a-form :form="form" v-if="userInfo != null && !isUpdate && userInfo.roleId !== 3">
        <ul class="user-info">
          <!-- LOGO -->
          <li v-if="userInfo.accRole && (isSchool || isInstitution)">
            <span class="key">LOGO:</span>
            <span class="value avatar">
              <c-upload accept="image/*" ossType="avatar" :isSingle="true" @uploadSuccess="uploadSuccess"
                :sourceFileList="sourceFileList"></c-upload>
            </span>
          </li>
          <!-- 课程方种类 -->
          <li v-if="userInfo.accRole && isInstitution">
            <span class="key">课程方种类：</span>
            <span class="value">
              {{
                userInfo.institutionType == 1
                  ? '社会企业'
                  : userInfo.institutionType == 2
                    ? '个人老师'
                    : userInfo.institutionType == 3
                      ? '高校与协会'
                      : ''
              }}
            </span>
          </li>
          <!-- 课程方名称 -->
          <li v-if="userInfo.accRole && isInstitution">
            <span class="key">课程方名称：</span>
            <span class="value">
              <a-form-item>
                <a-input type="text" v-decorator="[
                  'institutionName',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^.{2,45}$/,
                        message: '请输入长度为2~45位的课程方名字',
                      },
                    ],
                    validateTrigger: 'change',
                  },
                ]" />
              </a-form-item>
            </span>
          </li>
          <!-- 学校名称 -->
          <li v-if="userInfo.accRole && isSchool">
            <span class="key">学校名称：</span>
            <span class="value">
              <a-form-item>
                <a-input type="text" v-decorator="[
                  'schoolName',
                  {
                    rules: [
                      {
                        required: true,
                        pattern: /^.{2,75}$/,
                        message: '请输入长度为2~75位的学校名称',
                      },
                    ],
                    validateTrigger: 'change',
                  },
                ]" />
              </a-form-item>
            </span>
          </li>
          <!-- 咨询电话 -->
          <li v-if="userInfo.accRole && isInstitution">
            <span class="key">咨询电话：</span>
            <span class="value">
              <a-form-item>
                <a-input type="text" v-decorator="['phone']" />
              </a-form-item>
            </span>
          </li>
          <!-- 设置密码 -->
          <span class="update-password" @click="isUpdate = true" v-if="userInfo">{{ userInfo.hasPwd == '0' ? '设置密码' :
            '修改密码' }}</span>
          <!-- 用户名 -->
          <li>
            <span class="key">用户名：</span>
            <span class="value">{{ userInfo.username || '未设置用户名' }}</span>
          </li>
          <!-- 手机号 -->
          <li>
            <span class="key">手机号：</span>
            <span class="value">{{ userInfo.mobile || '未设置手机号' }}</span>
          </li>
          <!-- 姓名 -->
          <li>
            <span class="key">姓名：</span>
            <span class="value">{{ userInfo.nickname || '未设置姓名' }}</span>
          </li>
          <!-- 角色 -->
          <li>
            <span class="key">角色：</span>
            <span class="value">{{ userInfo.accRole.roleName }}</span>
          </li>
          <li v-if="userInfo.accRole && isSchool">
            <span class="key">学校属性：</span>
            <span class="value">{{
              userInfo.grandAndType.schoolAttributeTagNames
                ? userInfo.grandAndType.schoolAttributeTagNames
                : ''
            }}</span>
          </li>
          <li v-if="userInfo.accRole && isSchool">
            <span class="key">学校类型：</span>
            <span class="value">{{
              userInfo.grandAndType.schoolTypeTagNames
                ? userInfo.grandAndType.schoolTypeTagNames.toString()
                : ''
            }}</span>
          </li>
          <!-- 创建时间 -->
          <li>
            <span class="key">创建时间：</span>
            <span class="value">{{ userInfo.gmtCreate }}</span>
          </li>
          <!-- 简介 -->
          <li v-if="userInfo.accRole && (isSchool || isInstitution)">
            <span class="key">简介：</span>
            <span class="value">
              <a-form-item>
                <a-textarea placeholder="请输入" :autosize="{ minRows: 3, maxRows: 6 }" v-decorator="[
                  'intro',
                  {
                    validateTrigger: 'blur',
                  },
                ]" :maxLength="2000" />
              </a-form-item>
            </span>
          </li>
          <li v-if="userInfo.institutionType == 3">
            <span class="key">背景图片:</span>
            <span>
              <c-upload class="backgroundImage" accept="image/*" :imageMatchWidth="1125" :imageMatchHeight="375"
                :maxFileSize="2097152" :maxlength="1" :isSingle="true" @uploadSuccess="uploadSuccessBackgroundImg"
                :sourceFileList="sourceFileListBackgroundImg"></c-upload>
            </span>
          </li>
          <!-- 确认修改 -->
          <li class="update-user" v-if="userInfo.accRole && (isSchool || isInstitution)">
            <a-button type="primary" @click="updateUser()">确认修改</a-button>
          </li>
        </ul>
      </a-form>

      <a-form class="user-info input-width" layout="horizontal" :form="form" v-if="isUpdate" autocomplete="off">
        <a-form-item label="修改密码通过" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
          <a-radio-group v-model="type" button-style="solid" @change="form.resetFields()" style="width: 302px;">
            <a-radio-button :value="1" class="radio">
              当前密码
            </a-radio-button>
            <a-radio-button :value="2" class="radio">
              手机号验证码
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <div v-if="type == 2">
          <!-- 管理员手机号  -->
          <a-form-item label="管理员手机号" v-if="userInfo.hasPwd != '0'" :labelCol="{ lg: { span: 7 } }"
            :wrapperCol="{ lg: { span: 13 } }">
            <a-input placeholder="请输入" v-model.trim="userInfo.mobile" :maxLength="11"
              :disabled="userInfo.roleId !== 6" />
          </a-form-item>
          <!-- 图片验证码 -->
          <a-form-item label="图片验证码" v-if="userInfo.hasPwd != '0'" :labelCol="{ lg: { span: 7 } }"
            :wrapperCol="{ lg: { span: 13 } }">
            <div class="img-code">
              <a-input placeholder="请输入" v-decorator="[
                'imgCode',
                { rules: [{ required: true, message: '请输入图片验证码' }, { pattern: /^.{4}$/, message: '请输入4位验证码' }] },
              ]" style="width: 110px;" :maxLength="4" ref="imgCodeRef" />
              <div class="pic">
                <a @click="getImgCode(true)"><img :src="codeImg" alt=""></a>
              </div>
              <a-button type="primary" @click="getSmsCode" :disabled="timeCount > 0">
                {{ timeCount ? timeCount + '秒后再试' : '发送短信' }}
              </a-button>
            </div>
          </a-form-item>
          <!-- 短信验证码 -->
          <a-form-item label="短信验证码" v-if="userInfo.hasPwd != '0'" :labelCol="{ lg: { span: 7 } }"
            :wrapperCol="{ lg: { span: 13 } }">
            <a-input placeholder="请输入" :maxLength="6" v-decorator="[
              'smsCode',
              { rules: [{ required: true, message: '请输入短信验证码' }] },
            ]" />
          </a-form-item>

        </div>
        <!-- 请输入旧密码 -->
        <a-form-item label="请输入旧密码" v-if="userInfo.hasPwd != '0' && type == 1" :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }">
          <a-input type="password" placeholder="请输入" v-decorator="[
            'oldPassword',
            { rules: [{ required: true, message: '请输入旧密码' }] },
          ]" />
        </a-form-item>

        <!-- 请输入新密码 -->
        <a-form-item label="请输入新密码" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
          <a-input type="password" placeholder="请输入" v-decorator="[
            'password',
            { rules: [{ required: true, message: '' }, { validator: handleConfirmPass }] },
          ]" autocomplete="new-password" />
        </a-form-item>

        <!-- 重复新密码 -->
        <a-form-item label="重复新密码" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
          <a-input type="password" placeholder="请输入" v-decorator="[
            'repeatPassword',
            { rules: [{ required: true, message: '' }, { validator: handleConfirmPass }, { validator: confirmPassword_rule }] },
          ]" />
        </a-form-item>

        <a-form-item class="update-oper">
          <a-button type="primary" @click="confirmUpdate()" style="margin-right: 18px">确认修改</a-button>
          <a-button type="primary" @click="back" style="width: 88px;">返回</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
import user from '../../api/user'

import CUpload from '../../components/CUpload'

export default {
  name: 'userCenter',
  data() {
    return {
      form: this.$form.createForm(this),
      userInfo: null,
      isUpdate: false, //是否修改密码
      avatarUrl: '',
      sourceFileList: [],
      isSchool: false, //角色是学校
      isInstitution: false, //角色是课程方
      intro: false, //简介
      backgroundImg: '',
      sourceFileListBackgroundImg: [],
      type: 1,
      codeImg: '',
      timeCount: 0,
      sendSuccess: false,
    }
  },
  components: {
    CUpload,
  },
  methods: {
    //重复密码规则
    confirmPassword_rule(rule, value, callback) {
      if (value && value !== this.form.getFieldValue('password')) {
        callback('两次密码输入不一致')
      } else {
        callback()
      }
    },
    //头像上传成功之后回调
    uploadSuccess(url) {
      this.avatarUrl = url
    },
    uploadSuccessBackgroundImg(url) {
      this.backgroundImg = url
    },

    //修改用户信息
    updateUser() {
      let req = {
        imgUrl: this.avatarUrl || this.sourceFileList[0],
        backgroundImg:
          this.backgroundImg || this.sourceFileListBackgroundImg[0],
      }
      this.form.validateFields((err, value) => {
        if (!err) {
          if (this.isSchool) {
            req.id = this.userInfo.schoolId
            req.schoolName = value.schoolName.trim()
            if (!req.schoolName.length) {
              this.$message.error('学校名称不能为空')
              return
            }
          } else {
            req.id = this.userInfo.institutionId
            req.institutionName = value.institutionName
            req.phone = value.phone
          }
          req.intro = value.intro
          user.updateUserCenterInfo(req).then((res) => {
            this.$message.success('修改成功')
            this.$set(this.userInfo, 'hasPwd', '1')
          })
        }
      })
    },
    goHome() {
      if (this.userInfo.roleId == '3') {
        this.$router.push('termSynopsis')
      } else {
        this.$router.push('courseList')
      }
    },
    back() {
      if (this.userInfo.roleId !== 3) {
        this.isUpdate = false
      } else {
        this.$router.push('termSynopsis')
      }
    },
    //确认修改
    confirmUpdate() {
      this.form.validateFields((err, value) => {
        if (!err) {
          if (value.password != value.repeatPassword) {
            this.$message.error('两次密码输入值不同，请确认密码')
          } else {
            delete value.repeatPassword
            value.userId = this.userInfo.id
            if (this.type == 1) {
              user.updatePassword(value).then((res) => {
                this.$message.success('修改成功')
                this.form.resetFields()
                if (this.userInfo.roleId !== 3) {
                  this.isUpdate = false
                }
              })
            } else {
              let params = {
                mobile: this.userInfo.mobile,
                imageCode: value.imgCode,
                smscode: value.smsCode,
                password: value.password,
              }
              user.updatePasswordByMobile(params).then(res => {
                this.form.resetFields()
                this.$message.success('修改成功')
              })
            }
          }
        }
      })
    },
    handleConfirmPass(rule, value, callback) {
      if (!value) {
        callback(
          '请输入8-20位密码，需包含大小写字母、数字，字符不支持中文格式。'
        )
      } else if (!/^[\u0020-\u007e]{8,20}$/.test(value)) {
        callback('请输入长度为8~20位的密码')
      } else if (!/[A-Z]+/.test(value)) {
        callback('密码中需要包含大写字母')
      } else if (!/[a-z]+/.test(value)) {
        callback('密码中需要包含小写字母')
      } else if (!/\d+/.test(value)) {
        callback('密码中需要包含数字')
      }
      callback()
    },
    getSmsCode() {
      if (this.sendSuccess) return this.$message.error('请勿重复发送')
      setTimeout(() => {
        this.sendSuccess = false
      }, 180000);
      if (this.userInfo.roleId == 6) {
        if (!this.userInfo.mobile) return this.$message.error('请输入手机号码')
        const phoneRegex = /^1[3-9]\d{9}$/
        if (!phoneRegex.test(this.userInfo.mobile)) return this.$message.error('请输入正确的手机号码')
      }
      this.form.validateFields(['imgCode'], (err, values) => {
        if (!err) {
          let params = {
            mobile: this.userInfo.mobile,
            mode: 'reset_password',
            imageCode: values.imgCode,
          }
          user.getSmscode(params).then(res => {
            this.$message.success('验证码发送成功')
            this.sendSuccess = true
            this.timeCount = 60
            let timer = setInterval(() => {
              this.timeCount--
              if (this.timeCount <= 0) {
                clearInterval(timer)
              }
            }, 1000)
          })
        }
      })
    },
    getImgCode(focus) {
      user.getImgCode().then(res => {
        this.form.setFieldsValue({ imgCode: '' })
        this.codeImg = 'data:image/jpeg;base64,' + res.msg
        if (focus) {
          this.$refs.imgCodeRef.focus()
        }
        this.sendSuccess = false
      })
    },
  },
  created() {
    let self = this
    this.$store.commit('USERINFO', null)
    this.$store.dispatch('getUserInfo').then((res) => {
      if (res.roleId == 3) {
        this.isUpdate = true
      }
      this.userInfo = res
      this.isSchool = this.userInfo.accRole.id == '3'
      this.isInstitution = this.userInfo.accRole.id == '4'
      if (this.isSchool) {
        this.sourceFileList.push(this.userInfo.schoolImgUrl)
        setTimeout(() => {
          self.form.setFieldsValue({
            schoolName: self.userInfo.schoolName,
            intro: self.userInfo.intro,
          })
        }, 100)
      } else if (this.isInstitution) {
        setTimeout(() => {
          self.form.setFieldsValue({
            institutionName: self.userInfo.institutionName,
            phone: self.userInfo.phone,
            intro: self.userInfo.intro,
          })
        }, 100)
        this.sourceFileList.push(this.userInfo.institutionImgUrl)
        this.sourceFileListBackgroundImg.push(this.userInfo.backgroundImg)
      }
    })
  },
  mounted() {
    this.getImgCode()
  }
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.user-outer {
  margin: 0px auto;
  padding-top: 100px;
  text-align: center;
}

.user-inner {
  width: 500px;
  display: inline-block;
}

.user-header {
  text-align: left;
  padding: 0px 6px 18px;
  position: relative;

  .logo {
    display: inline-block;
    position: relative;
    padding-right: 10px;
    cursor: pointer;

    img {
      width: 38px;
      height: auto;
      margin-right: 6px;
      vertical-align: middle;
    }

    span {
      font-size: 20px;
      font-weight: 600;
      vertical-align: middle;
    }
  }

  .logo::after {
    content: '';
    width: 1px;
    height: 16px;
    position: absolute;
    top: 11px;
    right: 0px;
    background: $normal-color-disabled;
  }

  .title {
    vertical-align: middle;
    display: inline-block;
    padding-left: 10px;
    font-weight: 600px;
    font-size: 16px;
  }
}

.user-info {
  padding: 40px 0px;
  border: 1px solid $border-color;
  text-align: left;
  position: relative;

  li {
    margin: 15px 0px !important;
    font-size: 16px;
    line-height: 36px;

    .key {
      display: inline-block;
      width: 140px;
      text-align: right;
      vertical-align: top;
    }

    .value {
      vertical-align: top;
      padding-left: 10px;
      display: inline-block;
      padding-right: 16px;
      text-align: left;

      textarea {
        vertical-align: top;
        min-width: 300px;
      }

      input {
        min-width: 200px;
      }
    }

    .avatar {
      vertical-align: top;
    }
  }

  .update-oper {
    text-align: center;
  }

  .update-user {
    text-align: center;
  }
}

.update-password {
  color: $primary-color-dark;
  cursor: pointer;
  position: absolute;
  top: 62px;
  right: 30px;
}

//背景图
/deep/ .backgroundImage {
  display: inline-block;
  margin-left: 2px;
}

/deep/ .backgroundImage .ant-upload {
  width: 250px;
  height: 84px;
  border: 0;

  .ant-upload-text {
    display: none;
  }

  .ant-spin {
    width: 50%;
    height: 94%;
  }
}

/deep/ .backgroundImage .ant-spin-nested-loading {
  width: 250px;
}

/deep/ .backgroundImage .ant-upload-list-picture-card-container {
  width: 250px;
  height: 84px;
  border: 0;
}

/deep/ .backgroundImage .ant-upload-list-item {
  width: 250px;
  height: 84px;
  border: 0;
}

/deep/ .backgroundImage .image-upload {
  width: 250px;
  height: 84px;
  border: 0;
}

.img-code {
  display: flex;
  align-items: center;

  .pic {
    height: 40px;
    margin: 0 12px;

    img {
      width: 80px;
      height: 40px;
      border-radius: 4px;
    }
  }
}

.input-width {
  input {
    width: 302px;
  }
}

.radio {
  width: 151px;
  text-align: center;
}
</style>
